import { useMutation, useQueryClient } from '@tanstack/react-query';

import { invalidateClinicalBundle } from '../lib/invalidateSessionCaches';
import { sessionsService } from '../services';

import { sessionsKeys } from './useSessions';

export function useCreateCaseReport(sessionId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: { content: string }) => sessionsService.createCaseReport(sessionId, input),
    onSuccess: () => {
      void qc.invalidateQueries({
        queryKey: sessionsKeys.operation('case-reports', sessionId),
      });
      void qc.invalidateQueries({
        queryKey: sessionsKeys.operation('case-reports-meta', sessionId),
      });
      // The drawer renders from the clinical bundle, not the `case-reports` key —
      // refresh it so a freshly created report appears without a manual reload.
      invalidateClinicalBundle(qc, sessionId);
    },
  });
}
